import JSZip from 'jszip';
import { saveAs } from 'file-saver';
// import { storage, ref, listAll, getDownloadURL } from '../../storage/firebase';
import { firebaseStore } from '../../storage/base';

export const downloadFolderAsZip = async (folderPath) => {
  console.log('Starting folder download...');

  const jszip = new JSZip();
  const storage = firebaseStore.storage();
  const folderName = 'settings'; // Your folder name

  try {
    const folderRef = storage.ref(folderName);
    console.log('Folder reference created:', folderRef);

    const downloadFiles = async (folderRef, path) => {
      const folder = await storage.ref(folderRef.fullPath).listAll();
      console.log('Folder:', path);
      console.log('Files in the folder:', folder.items);

      const promises = folder.items.map(async (item) => {
        console.log('Downloading file:', item.name);
        const file = await item.getMetadata();
        const fileRef = storage.ref(item.fullPath);
        const fileBlob = await fileRef.getDownloadURL().then((url) =>
          fetch(url).then((response) => {
            if (!response.ok) {
              console.error('Failed to fetch file:', item.name);
              throw new Error('Failed to fetch file');
            }
            return response.blob();
          })
        );
        jszip.folder(path).file(item.name, fileBlob);
      });

      await Promise.all(promises);

      // for (const subfolder of folder.prefixes) {
      //   downloadFiles(subfolder, `${path}${subfolder.name}/`);
      // }
    };

    await downloadFiles(folderRef, '');

    console.log('Number of files added to the ZIP:', jszip.files.length);

    if (jszip.files.length === 0) {
      console.log('ZIP is empty.');
      return;
    }

    const blob = await jszip.generateAsync({ type: 'blob' });
    saveAs(blob, 'download.zip');
    console.log('Download completed.');
  } catch (error) {
    console.error('Error:', error);
    alert('An error occurred while downloading the folder.');
  }
};
